import type { IconData } from '@stacksjs/iconify-core'

export const gl1x1: IconData = {
  "body": "<path fill=\"#fff\" d=\"M0 0h512v512H0z\"/><path fill=\"#d00c33\" d=\"M0 256h512v256H0zm53.3 0a170.7 170.7 0 1 0 341.4 0a170.7 170.7 0 0 0-341.4 0\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default gl1x1
